module.exports = __webpack_public_path__ + "static/media/whats.175241c0.svg";